import InfoIndicator from "@app/shared/InfoIndicator";
import { JSX } from "react";
import { toast, Id } from "react-toastify";

function dismissDistanceResult(toastId: Id): void {
  toast.dismiss(toastId);
}

function toastDistanceResult(distance: number, toastId: Id): void {
  if (toast.isActive(toastId)) {
    toast.update(toastId, {
      containerId: "z-index-1030",
      render: <DistanceResultToastBody distance={distance} />,
    });
  } else {
    toast.info(
      <DistanceResultToastBody distance={distance} />,
      {
        autoClose: false,
        containerId: "z-index-1030",
        draggable: false,
        toastId,
      },
    );
  }
}

function DistanceResultToastBody(props: { distance: number }): JSX.Element {
  return (
    <>
      <span className="mtb5">
        <InfoIndicator tooltipTitle="Due to the nature of estimated driving distance, mileage may differ for the same pair of providers when the starting provider and destination provider are reversed." tooltipPlacement="left" />
        <span>&nbsp;</span>
        The distance between the two providers<br />is about <strong>{props.distance} {props.distance === 1 ? "mile" : "miles"}</strong>.
      </span>
    </>
  );
}

export {
  dismissDistanceResult as dismiss,
  toastDistanceResult as toast,
};
